import { render, staticRenderFns } from "./ItemRecordTrainer.vue?vue&type=template&id=11edcfe9&scoped=true&lang=pug&"
import script from "./ItemRecordTrainer.vue?vue&type=script&lang=js&"
export * from "./ItemRecordTrainer.vue?vue&type=script&lang=js&"
import style0 from "./ItemRecordTrainer.vue?vue&type=style&index=0&id=11edcfe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11edcfe9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
